import styled from 'styled-components'

interface IFileInfoStyledProps {
  error?: boolean
}

export const FileInfoStyled = styled.div<IFileInfoStyledProps>`
  display: flex;

  flex-direction: column;
  justify-content: center;

  text-align: left;

  .filename {
    line-height: 1.5;
    font-weight: ${(props) => props.theme.fontWeights.semibold};
  }

  .filemeta {
    display: block;
    line-height: 1.5;
    color: ${(props) =>
      props.error ? props.theme.colors.danger : props.theme.colors.darkGrey};
  }
`
